<template>
    <div v-if="loading">
        <vx-card>
            <h3> Loading... Please wait...</h3>
        </vx-card>
    </div>
    <vx-card v-else>
        <div class="vx-row">
            <div class="vx-col w-full mb-3">
                <vs-input
                    class="w-full"
                    label="Share Name"
                    placeholder="Enter name of the share"
                    v-model="share.name"
                    :warning="api_errors.name"
                    :warning-text="api_errors.name?api_errors.name[0]:null"
                />
            </div>
            <div class="vx-col w-full mb-3">
                <vs-input
                    class="w-full"
                    label="Scrip Name"
                    placeholder="Enter name of the Scrip"
                    v-model="share.scrip_name"
                    :warning="api_errors.scrip_name"
                    :warning-text="api_errors.scrip_name?api_errors.scrip_name[0]:null"
                />
            </div>
            <div class="vx-col w-full mb-3">
                <vs-input
                    class="w-full"
                    label="Grandfather Cost (as on 31/01/2018)"
                    placeholder="Enter MVP of script, or set as 0"
                    type="Number"
                    step="0.001"
                    v-model="share.gf_cost_31012018"
                    :warning="api_errors.gf_cost_31012018"
                    :warning-text="api_errors.gf_cost_31012018 ? api_errors.gf_cost_31012018[0] : null"
                />
            </div>
            <div class="vx-col w-full mb-3">
                <SelectForeign
                    :model.sync="share.scrip_type"
                    label="Scrip Type"
                    placeholder="Type to Search.."
                    :multiple="false"
                    :load_initial="true"
                    :label_keys="['name',]"
                    input_class="w-full mt-0"
                    style="min-width: 200px;"
                    :show_id_in_label="false"
                    :endpoint="$store.state.apiendpoints.scrip_type_list"
                    container_class="w-full"
                    :use_id_as_value="false"
                    :warning="api_errors.scrip_type"
                    :warning-text="api_errors.scrip_type ? api_errors.scrip_type[0]:null"
                    list_length="10000"
                />
            </div>
            <div class="vx-col w-full mb-3">
                <SelectForeign
                    :model.sync="share.industry"
                    label="Industry"
                    placeholder="Type to Search.."
                    :multiple="false"
                    :load_initial="true"
                    :label_keys="['name',]"
                    :show_id_in_label="false"
                    :endpoint="$store.state.apiendpoints.industry_list"
                    input_class="w-full mt-0"
                    style="min-width: 200px;"
                    container_class="w-full"
                    :use_id_as_value="false"
                    :warning="api_errors.industry"
                    :warning-text="api_errors.industry ? api_errors.industry[0]:null"
                    list_length="10000"
                />
            </div>
            <div class="vx-col w-full mt-3 text-center">
                <vs-button
                    color="primary"
                    type="filled"
                    @click.prevent="save"
                    :disabled="submit_disabled"
                >Save</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>

import {Request} from "../../utils/requests"

export default {
    data() {
        return {
            loading: true,

            share: {
                name: null,
                gf_cost_31012018: 0,
                scrip_name: null,
                scrip_type: null,
                industry: null
            },
            share_id: this.$route.params.share_id,
            submit_disabled: false,
            api_errors: {}
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route.params.share_id'(newV) {
            this.init()
        }
    },
    methods: {
        init() {
            this.share_id = this.$route.params.share_id
            if(this.share_id){
                this.loadData()
            } else {
                this.loading = false
                this.share = {
                    name: null,
                    gf_cost_31012018: 0,
                    scrip_name: null,
                    scrip_type: null,
                    industry: null
                }
            }
        },
        loadData() {
            this.loading = true
            this.$vs.loading()

            let url = this.$store.state.apiendpoints.share + this.share_id + "/"

            Request(this, 'GET', url).then(
                (res) => {
                    this.share = res
                    this.loading = false
                    this.$vs.loading.close()
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured while loading data. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    this.loading = false
                    this.$vs.loading.close()
                    this.$router.push("/")
                }
            )
        },
        save(){
            let $this = this
            let url = $this.$store.state.apiendpoints.share, request_method = 'POST'

            if(this.share_id){
                url += this.share_id + "/"
                request_method = 'PUT'
            }

            let data = {...this.share}

            this.submit_disabled = true

            Request($this, request_method, url, null, data).then(
                (res) => {
                    $this.$vs.notify({
                        time: 2500,
                        title: 'Saved',
                        text: 'Saved Successfully',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    })
                    this.submit_disabled = false
                    $this.$router.push({name: 'share-list'})
                },
                (err) => {
                    if(err.error) {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please check all fields and Try Again.',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        this.api_errors = err.error
                    } else {
                        $this.$vs.notify({
                            time: 2500,
                            title: 'Unknown Error',
                            text: 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                    this.submit_disabled = false
                }
            )
        }
    }
}
</script>
